const qrCodeModel = {
  /**
   * 居住証明入力チェック
   * @param {*} data
   * @returns
   */
  validationCertificateInput(data) {
    const {
      landDate,
      type,
      issueDate,
      livingDate,
      domicile,
      source,
      number,
    } = data;
    const errorItems = [];
    // 発行日
    if (!landDate) {
      errorItems.push('landDate');
    }
    // 証明書の種類
    if (!type) {
      errorItems.push('type');
    }
    // 発行日
    if (!issueDate) {
      errorItems.push('issueDate');
    }
    // 国外に住所を定めた日
    if (!livingDate) {
      errorItems.push('livingDate');
    }
    // 本籍地
    if (!domicile.trim().length) {
      errorItems.push('domicile');
    }
    // 海外在留証明の場合
    if (Number(type) === 2) {
      // 発行元公館名
      if (!source.trim().length) {
        errorItems.push('source');
      }
      // 発行番号
      if (!number.trim().length) {
        errorItems.push('number');
      }
    }
    return errorItems;
  },

  /**
   * 直近の入国日（帰国日）と発行日の差分チェック
   * @param {*} landDate YYYYMMDD
   * @param {*} issueDate YYYYMMDD
   */
  checkDiffLandDateAndIssueDate(landDate, issueDate) {
    const validationDate = window.$vm.$moment(landDate, 'YYYYMMDD').subtract(6, 'months');
    const mIssueDate = window.$vm.$moment(issueDate, 'YYYYMMDD');
    return mIssueDate.isBefore(validationDate);
  },

  /**
   * 発行日と国外に住所を定めた日の差分(滞在日数の)チェック
   * @param {*} issueDate YYYYMMDD
   * @param {*} livingDate YYYYMMDD
   */
  checkDiffIssueDateAndLivingDate(issueDate, livingDate) {
    const validationDate = window.$vm.$moment(issueDate, 'YYYYMMDD').subtract(2, 'years');
    const mLivingDate = window.$vm.$moment(livingDate, 'YYYYMMDD');
    return mLivingDate.isAfter(validationDate);
  },

  /**
   * 発行日付が未来日でないかのチェック
   * @param {*} issueDate
   */
  checkFutureIssueDate(issueDate) {
    const now = window.$vm.$moment(window.$vm.$moment().format('YYYY-MM-DD 00:00:00'), 'YYYY-MM-DD');
    const mIssueDate = window.$vm.$moment(issueDate, 'YYYY-MM-DD');
    const diff = mIssueDate.diff(now, 'days');
    return (diff >= 1);
  },

  /**
   * 日付が過去日付かのチェック
   * @param {*} date
   */
  checkPastDate(date) {
    const now = window.$vm.$moment(window.$vm.$moment().format('YYYY-MM-DD 00:00:00'), 'YYYYMMDD');
    const mDate = window.$vm.$moment(date, 'YYYYMMDD');
    const diff = mDate.diff(now, 'days');
    return (diff < 0);
  },

  /**
   * QRコードの内容作成
   * @param {*} str
   * @param {*} landDate YYYYMMDD
   * @returns
   */
  createQrHeaderAndQrBody(str, landDate) {
    const qrBodys = str.split('');
    const trimIndex = Math.floor(Math.random() * (qrBodys.length - 1));
    let trimStr = '';
    const newQrBodys = [];
    const max = Math.floor(Math.random() * 5) + 1; // 1 ~ 5の間でランダム
    for (let i = 0; i < qrBodys.length; i += 1) {
      const char = qrBodys[i];
      if (i < trimIndex) {
        newQrBodys.push(char);
        continue;
      }
      if (trimStr.length < max) {
        trimStr += char;
        continue;
      }
      newQrBodys.push(char);
    }

    return {
      header: {
        i: trimIndex,
        p: trimStr,
        e: window.$vm.$moment(landDate, 'YYYYMMDD').add(183, 'days').format('YYYYMMDDHHmmss'),
      },
      body: newQrBodys.join(''),
    };
  },
};

export default qrCodeModel;
